import { QueryClientProvider } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { ThemeProvider } from '@lb/ui'

import { queryClient } from '../../lib/client'
import { SessionProvider } from './session'
import { StormProvider } from './storm'

/**
 * The provider stack (architecture §6.5). Order is load-bearing:
 *
 *   QueryClient   the server cache, needed by everything below
 *   Theme         writes data-theme on <html>
 *   Session       gates routes — must sit above the router
 *   Storm         the SOS is reachable from every screen, so it is ABOVE the
 *                 router: opening it must not be a navigation (§6.8)
 *
 * i18n initialises before render in main.tsx rather than as a provider, so no
 * screen can paint a translation key.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <SessionProvider>
          <StormProvider>{children}</StormProvider>
        </SessionProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}
